import { registerPlugin } from '@capacitor/core'

const iZettlePlugin = registerPlugin<any>('iZettlePlugin')

export { iZettlePlugin }
